import { Toaster } from "@odus/ui";
import {
  Link,
  Outlet,
  createRootRoute,
  createRoute,
  createRouter,
  redirect,
} from "@tanstack/react-router";

import { EntrarPage } from "./routes/entrar";

function NotFound() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="font-display text-h2-sm">Página não encontrada</h1>
      <Link to="/entrar" data-track="app.not_found.home" className="text-gold-text underline">
        Ir para a entrada
      </Link>
    </main>
  );
}

const rootRoute = createRootRoute({
  component: () => (
    <>
      <Outlet />
      <Toaster />
    </>
  ),
  notFoundComponent: NotFound,
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  beforeLoad: () => {
    throw redirect({ to: "/entrar" });
  },
});

const entrarRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/entrar",
  component: EntrarPage,
});

export const router = createRouter({
  routeTree: rootRoute.addChildren([indexRoute, entrarRoute]),
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
